export default "__VITE_ASSET__Chagtpe0__"